
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      form: {
        text: '',
        point: 5,
      },
      loading: false,
      alertBox: {
        status: false,
        message: '',
      },
    }
  },
  props: {
    product: {
      default: () => {},
    },
    blogger: {
      default: false,
      type: Boolean,
    },
  },
  computed: {
    ...mapGetters({
      getActiveUser: 'user/getActiveUser',
    }),
  },
  methods: {
    async SEND_TO_COMMENT(e) {
      e.preventDefault()
      this.loading = true
      this.alertBox.status = false
      const response = await this.$api.post('Comments', {
        ...this.form,
        productId: this.product.id,
      })
      if (response.message === 'OK') {
        this.alertBox = {
          status: true,
          message: this.$custom$t('valid.successComment'),
          variant: 'success',
        }
        this.form = {
          text: '',
          point: 5,
        }
      } else {
        this.alertBox = {
          status: true,
          message: this.$custom$t('valid.errorComment'),
          variant: 'danger',
        }
      }
      this.loading = false
    },
  },
}
